







import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import { toDCM } from '@/helper'

@Component({
    components: {},
    filters: {
        toDCM,
    },
})
export default class MArketCap extends Vue {
    get prices(): any {
        return this.$store.state.prices
    }

    get currentSupply() {
        return this.$root.$store.state.Metrics.currentSupply
    }

    get marketCap() {
        const usd = this.prices?.usd
        return this.inDCM * usd
    }

    get inDCM() {
        const supply = parseInt(this.currentSupply?.supply || '0')

        return toDCM(supply, 9)
    }
    convertNum(num: number) {
        if (num > 999 && num < 1000000) {
            return (num / 1000).toFixed(1) + 'K'
        } else if (num > 1000000) {
            return (num / 1000000).toFixed(1) + 'M'
        } else if (num < 900) {
            return num
        }
    }
}
